import {
  ITitleTextCenteredColoredCard,
  TitleTextCenteredColoredCardProps,
} from './types';

export const mapTitleTextCenteredColoredCard = ({
  prismicContent: { primary },
}: {
  prismicContent: TitleTextCenteredColoredCardProps['slice'];
}): ITitleTextCenteredColoredCard => {
  const { background_color: backgroundColor } = primary;

  return {
    ...primary,
    backgroundColor: backgroundColor as string,
  };
};
